export const isUUID = (uuid) => {
  return typeof uuid === 'string' && uuid.length === 36
}

export default () => {
  const s4 = () => Math.floor((1 + Math.random()) * 0x10000).toString(16).substring(1)
  return s4() + s4() + '-' + s4() + '-' + s4() + '-' + s4() + '-' + s4() + s4() + s4()
}
